import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Success / failure popup shown after a publish attempt.
export function PublishResultDialog({ publishResult, setPublishResult, onRetry, navigate }) {
  return (
    <Dialog open={!!publishResult} onOpenChange={(v) => { if (!v) setPublishResult(null); }}>
      <DialogContent data-testid="publish-result-dialog">
        <DialogHeader><DialogTitle>{publishResult?.ok ? "Published Successfully" : "Failed To Publish"}</DialogTitle></DialogHeader>
        {publishResult?.ok ? (
          <div className="space-y-4" data-testid="publish-success">
            <p className="text-sm text-zinc-600">Your reaction is on its way to YouTube — check your channel.</p>
            <div className="flex items-center justify-end gap-3">
              {publishResult.url && <a href={publishResult.url} target="_blank" rel="noreferrer" data-testid="publish-open-youtube" className="text-sm text-rose-600 hover:text-rose-700 underline">Open on YouTube</a>}
              <button onClick={() => { setPublishResult(null); navigate("/dashboard"); }} data-testid="publish-done-btn"
                className="bg-zinc-900 hover:bg-zinc-800 text-white text-sm font-medium rounded-[4px] px-6 py-2 transition-colors">Done</button>
            </div>
          </div>
        ) : (
          <div className="space-y-4" data-testid="publish-failure">
            <p className="text-sm text-zinc-600">{publishResult?.message || "We couldn't publish your reaction. Check your YouTube connection in Settings and try again."}</p>
            <div className="flex items-center justify-end gap-3">
              <button onClick={() => setPublishResult(null)} data-testid="publish-dismiss-btn" className="text-sm text-zinc-600 hover:text-zinc-900 px-4 py-2 transition-colors">Close</button>
              {publishResult?.canRetry && (
                <button onClick={() => { setPublishResult(null); onRetry(); }} data-testid="publish-retry-btn"
                  className="bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-[4px] px-6 py-2 transition-colors">Try upload again</button>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
